import { code } from "@spscommerce/utils";
import { DSReactExamples } from "@spscommerce/ds-shared";

export const SpsRadioButtonExamples: DSReactExamples = {
    labels: {
        label: "Labels",
        description: "info about radio buttons with labels",
        examples: {
            label: {
                react: code`
                    function DemoComponent() {
                        const { formValue, formMeta, updateForm } = useSpsForm({
                            color: "blue"
                        });

                        return <SpsForm formMeta={formMeta} id="labelRadioButton">
                            <SpsRadioButton name="blue" value="blue" label="Blue"
                                formMeta={formMeta.fields.color}
                                checked={formValue.color === "blue"}
                            ></SpsRadioButton>
                            <SpsRadioButton name="green" value="green" label="Green"
                                formMeta={formMeta.fields.color}
                                checked={formValue.color === "green"}
                            ></SpsRadioButton>
                        </SpsForm>
                    }
                `
            }
        }
    },
    b_disabled: {
        label: "Disabled",
        description: "info about disabled radio buttons",
        examples: {
            disabled: {
                react: code`
                    function DemoComponent() {
                        const { formValue, formMeta, updateForm } = useSpsForm({
                            color: "blue"
                        });

                        return <SpsForm formMeta={formMeta}>
                            <SpsRadioButton name="blue" value="blue" label="Blue"
                                formMeta={formMeta.fields.color}
                                checked={formValue.color === "blue"}
                                disabled
                            ></SpsRadioButton>
                            <SpsRadioButton name="green" value="green" label="Green"
                                formMeta={formMeta.fields.color}
                                checked={formValue.color === "green"}
                                disabled
                            ></SpsRadioButton>
                        </SpsForm>
                    }
                `
            }
        }
    },
    c_noLabels: {
        label: "No Labels",
        description: "info about radio buttons without labels",
        examples: {
            noLabels: {
                react: code`
                    function DemoComponent() {
                        const { formValue, formMeta, updateForm } = useSpsForm({
                            color: "green"
                        });

                        return (
                            <SpsForm formMeta={formMeta}>
                                <SpsRadioButton name="blue" value="blue"
                                    formMeta={formMeta.fields.color}
                                    checked={formValue.color === "blue"}
                                ></SpsRadioButton>
                                <SpsRadioButton name="green" value="green"
                                    formMeta={formMeta.fields.color}
                                    checked={formValue.color === "green"}
                                ></SpsRadioButton>
                            </SpsForm>
                        )
                    }
                `
            }
        }
    }
};
